import React from 'react'
import { useTranslation } from 'react-i18next'
import {observer} from 'mobx-react'
import {Form, Input, Modal, Typography} from 'antd'
import {ModalFormFooter} from '@/components'
import {UnregisterReasonConfirmModalProps} from './props'
import {REASON_INPUT_DOMAIN} from '@/constants/playwright-ids'

export const UnregisterReasonConfirmModal: React.FC<UnregisterReasonConfirmModalProps> = observer((
    {open, onOk, onCancel, confirmLoading}
) => {
    const { t } = useTranslation()
    const [form] = Form.useForm()

    const onFinish = async (values) => {
        await onOk(values)
        form.resetFields()
    }

    const onCancelClick = (e) => {
        form.setFieldsValue({
            reason: ''
        })
        onCancel(e)
    }

    return (
        <Modal
            title={t('UnregisterReasonConfirmModal.title')}
            open={open}
            onCancel={onCancelClick}
            footer={<ModalFormFooter
                formId={'unregister-domain'}
                onCancel={onCancelClick}
                cancelText={t('UnregisterReasonConfirmModal.close')}
                confirmLoading={confirmLoading}
                okText={t('UnregisterReasonConfirmModal.unregister')}
            />}
        >
            <Typography.Text type={'secondary'}>
                {t('UnregisterReasonConfirmModal.pleaseEnterReasonWhyUnregistering')}
            </Typography.Text>
            <br/><br/>
            <Form
                form={form}
                id={'unregister-domain'}
                layout={'vertical'}
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                initialValues={{ remember: true }}
                onFinish={onFinish}
                autoComplete='off'
            >
                <Form.Item
                    name={'reason'}
                    rules={[
                        { required: true, message: t('UnregisterReasonConfirmModal.errors.reasonRequired') }
                    ]}
                >
                    <Input.TextArea
                        data-test-id={REASON_INPUT_DOMAIN}
                    />
                </Form.Item>
            </Form>
        </Modal>
    )
})
